module.exports = __webpack_public_path__ + "img/name-icon.031641cc.svg";